import { ComponentType, ReactNode } from 'react';
import { useInRouterContext } from 'react-router-dom';
import clsx from 'clsx';

import AppShell from 'components/app-shell';
import feature from 'lib/utils/feature';

import Column from './column';
import Columns from './columns';

interface LayoutProps {
	Sidebar?: ComponentType | null;
	children: ReactNode;
	floatingControls?: ReactNode;
}

export default function Layout( { Sidebar = null, children, floatingControls = null }: LayoutProps ) {
	// The redesigned shell derives its navigation from the route, so it needs a router. The Gutenberg
	// block preview renders <Layout> outside one and keeps the legacy frame.
	const inRouter = useInRouterContext();

	if ( feature( 'wpcloud-redesign' ) && inRouter ) {
		return (
			<AppShell hasNav={ !! Sidebar } contextBar={ floatingControls }>
				{ children }
			</AppShell>
		);
	}

	return (
		<div
			className={
				clsx(
					'relative flex items-stretch pl-4',
					'pt-4 pr-4 pb-4',
					{
						'layout--with-sidebar sm:pl-[var(--hpp-sidebar-width)]': !! Sidebar,
						'layout--without-sidebar': ! Sidebar,
					},
				)
			}
		>
			{ Sidebar && <Sidebar /> }
			{ floatingControls }
			{ children }
		</div>
	);
}

export { Column, Columns };
